import React, { Fragment } from 'react'
import { HrefLangHeadProps } from './HrefLangHead.d'

const HrefLangHead = ({
  canonical,
  currentLanguage,
  defaultSiteUrl,
  localizedEntries,
  slug
}: HrefLangHeadProps) => {
  const getSlug = (slug: string) => {
    return !slug || slug === '/on-the-line'
      ? ''
      : slug.startsWith('/')
      ? slug
      : `/${slug}`
  }
  return (
    <>
      {localizedEntries.map((entry: any) => {
        if (entry.language) {
          const slug = entry.slug === '' ? entry.slug : `/${entry.slug}`
          const trimmedUrl = entry.url?.startsWith('/')
            ? entry.url.slice(1)
            : entry.url
          let siteUrl: string | string[] = defaultSiteUrl.split('/')
          if (entry?.language && entry.language !== 'en-US') {
            siteUrl.splice(3, 0, trimmedUrl)
          }
          siteUrl = siteUrl.join('/')

          return (
            <Fragment key={entry.language}>
              <link
                href={`${siteUrl}${getSlug(slug)}`}
                hrefLang={entry.language.toLowerCase()}
                rel='alternate'
              />
              {entry.language === 'en-US' && ( // en-US always default
                <link
                  href={`${siteUrl}${getSlug(slug)}`}
                  hrefLang='x-default'
                  rel='alternate'
                />
              )}
            </Fragment>
          )
        } else {
          return <></>
        }
      })}
    </>
  )
}

export default HrefLangHead
